export default __webpack_public_path__ + "static/media/hugo-208.e04bbe1e.png";